(() => {
  const init = (root) => {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const one = (s) => root.querySelector(s);
    const all = (s) => [...root.querySelectorAll(s)];
    const policyDialog = one('[data-policy-dialog]');
    if (policyDialog) {
      let policyOpener;
      let previousOverflow;
      all('[data-policy-open]').forEach(trigger => trigger.addEventListener('click', () => {
        if (policyDialog.open) return;
        policyOpener = trigger;
        previousOverflow = document.documentElement.style.overflow;
        policyDialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        one('[data-policy-title]').focus({preventScroll:true});
      }));
      one('[data-policy-close]').addEventListener('click', () => policyDialog.close());
      policyDialog.addEventListener('click', event => {
        if (event.target !== policyDialog) return;
        const box = policyDialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) policyDialog.close();
      });
      policyDialog.addEventListener('close', () => {
        document.documentElement.style.overflow = previousOverflow;
        policyOpener?.focus({preventScroll:true});
      });
    }
    // Anchor each newly initialized press rail to its first publication.
    const landingMenu = one('.nf-landing-menu');
    if (landingMenu) {
      landingMenu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => { landingMenu.open = false; }));
      landingMenu.addEventListener('keydown', event => {
        if (event.key === 'Escape') { landingMenu.open = false; landingMenu.querySelector('summary').focus(); }
      });
    }
    const reviewToggle = one('.nf-review-toggle');
    reviewToggle?.addEventListener('click', () => {
      const expanded = reviewToggle.getAttribute('aria-expanded') !== 'true';
      reviewToggle.setAttribute('aria-expanded', String(expanded));
      reviewToggle.textContent = expanded ? 'Show less' : 'Read more';
      one('[data-review-excerpt]').hidden = expanded;
      one('[data-review-full]').hidden = !expanded;
    });
    all('[data-open-precautions]').forEach(link => link.addEventListener('click', () => {
      const precautions = one('#nf-precautions');
      if (precautions) precautions.open = true;
    }));
    const chatButton = one('[data-nf-chat]');
    chatButton?.addEventListener('click', async () => {
      const status = one('.nf-chat-status');
      chatButton.disabled = true;
      status.textContent = 'Opening chat…';
      try {
        await new Promise((resolve, reject) => {
          const finish = error => {
            clearTimeout(timer);
            window.removeEventListener('gorgias-widget-loaded', loaded);
            error ? reject(error) : resolve();
          };
          const loaded = () => finish();
          const timer = setTimeout(() => finish(new Error('Chat unavailable')), 15000);
          window.addEventListener('gorgias-widget-loaded', loaded, {once:true});
          if (window.GorgiasChat) {
            Promise.resolve(window.GorgiasChat.init()).then(loaded, finish);
          } else if (!document.querySelector('script[src*="config.gorgias.chat"]')) {
            const script = document.createElement('script');
            script.id = 'gorgias-chat-widget-install-v3';
            script.src = 'https://config.gorgias.chat/bundle-loader/01GYCBPT41R1XRTJJ7H64NXF1V';
            script.async = true;
            script.onerror = () => { script.remove(); finish(new Error('Chat unavailable')); };
            document.body.appendChild(script);
          }
        });
        await window.GorgiasChat.open();
        status.textContent = '';
      } catch (error) {
        status.textContent = 'Chat couldn’t load. Please try again.';
      } finally {
        chatButton.disabled = false;
      }
    });
    const pressRail = one('.nf-press');
    if (pressRail) pressRail.scrollLeft = 0;
    const track = one('.nf-gallery-track');
    const slides = all('.nf-gallery-slide');
    const thumbs = all('[data-gallery-index]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    let imageIndex = 0;
    const syncGallery = () => {
      imageIndex = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      thumbs.forEach((b, i) => b.setAttribute('aria-pressed', String(i === imageIndex)));
      one('[data-gallery-status]').textContent = `Image ${imageIndex + 1} of ${slides.length}`;
      // Scroll only the thumbnail rail, never the page or the sticky gallery.
      const rail = one('.nf-thumbs'); const thumb = thumbs[imageIndex];
      const r = rail.getBoundingClientRect(); const t = thumb.getBoundingClientRect();
      if (rail.scrollWidth > rail.clientWidth) {
        if (t.left < r.left || t.right > r.right) rail.scrollLeft += t.left - r.left - (r.width - t.width) / 2;
      } else if (t.top < r.top || t.bottom > r.bottom) rail.scrollTop += t.top - r.top - (r.height - t.height) / 2;
    };
    const showImage = (index, behavior = reduced.matches ? 'instant' : 'smooth') => {
      imageIndex = (index + slides.length) % slides.length;
      track.scrollTo({left:imageIndex * track.clientWidth, behavior});
    };
    track.addEventListener('scroll', syncGallery, {passive:true});
    thumbs.forEach(b => b.addEventListener('click', () => showImage(Number(b.dataset.galleryIndex))));
    one('[data-gallery-prev]').addEventListener('click', () => showImage(imageIndex - 1));
    one('[data-gallery-next]').addEventListener('click', () => showImage(imageIndex + 1));
    track.addEventListener('keydown', e => {
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
      e.preventDefault();
      showImage(e.key === 'Home' ? 0 : e.key === 'End' ? slides.length - 1 : imageIndex + (e.key === 'ArrowRight' ? 1 : -1));
    });
    // Keep the selected image aligned after rotating a phone or resizing the window.
    const galleryResize = new ResizeObserver(() => showImage(imageIndex, 'instant'));
    galleryResize.observe(track);
    // Vertical wheel gestures retain normal page scrolling.
    // Add mouse dragging without overriding native touch scrolling.
    all('.nf-gallery-track,.nf-scroll,.nf-thumbs').forEach(rail => {
      let drag = null; let suppressClick = false;
      rail.addEventListener('dragstart', e => e.preventDefault());
      rail.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('video,iframe')) return;
        suppressClick = false;
        drag = {x:e.clientX,y:e.clientY,left:rail.scrollLeft,top:rail.scrollTop,index:imageIndex,moved:false,id:e.pointerId};
      });
      rail.addEventListener('pointermove', e => {
        if (!drag) return;
        const dx=e.clientX-drag.x; const dy=e.clientY-drag.y;
        const vertical=rail === one('.nf-thumbs') && rail.scrollHeight > rail.clientHeight;
        if (!drag.moved && Math.abs(vertical ? dy : dx) < 5) return;
        drag.moved = true; suppressClick = true;
        rail.setPointerCapture(e.pointerId); rail.classList.add('is-dragging'); e.preventDefault();
        if (vertical) rail.scrollTop = drag.top - dy; else rail.scrollLeft = drag.left - dx;
      });
      const finish = e => {
        if (!drag) return;
        const d = drag; drag = null; rail.classList.remove('is-dragging');
        if (rail.hasPointerCapture(d.id)) rail.releasePointerCapture(d.id);
        if (rail === track && d.moved) {
          const dx = e.clientX - d.x;
          const next = Math.abs(dx) > 40 ? d.index + (dx < 0 ? 1 : -1) : d.index;
          showImage(Math.max(0, Math.min(slides.length - 1, next)));
        }
      };
      rail.addEventListener('pointerup', finish); rail.addEventListener('pointercancel', finish);
      rail.addEventListener('pointerleave', e => { if (drag && !drag.moved) drag=null; });
      rail.addEventListener('click', e => {if (suppressClick) {e.preventDefault();e.stopPropagation();suppressClick=false;}}, true);
    });
    // Play customer videos in their own cards; only load a player after a click.
    const storyRail = one('.nf-testimonial-rail');
    let storyResize;
    if (storyRail) {
      const previous = one('[data-testimonial-prev]');
      const next = one('[data-testimonial-next]');
      const syncStoryArrows = () => {
        previous.disabled = storyRail.scrollLeft <= 2;
        next.disabled = storyRail.scrollLeft >= storyRail.scrollWidth - storyRail.clientWidth - 2;
      };
      const moveStories = direction => storyRail.scrollBy({left:direction * (storyRail.firstElementChild.offsetWidth + parseFloat(getComputedStyle(storyRail).gap)),behavior:reduced.matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => moveStories(-1));
      next.addEventListener('click', () => moveStories(1));
      storyRail.addEventListener('scroll', syncStoryArrows, {passive:true});
      storyRail.addEventListener('keydown', e => {
        if (e.target !== storyRail || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        if (e.key === 'Home' || e.key === 'End') storyRail.scrollTo({left:e.key === 'Home' ? 0 : storyRail.scrollWidth,behavior:'instant'});
        else moveStories(e.key === 'ArrowRight' ? 1 : -1);
      });
      storyResize = new ResizeObserver(syncStoryArrows);
      storyResize.observe(storyRail);
      syncStoryArrows();
      const stopOtherStories = active => {
        all('.nf-testimonial-media video').forEach(video => {if (video !== active) video.pause();});
        all('.nf-testimonial-media iframe').forEach(frame => {
          if (frame !== active) {const media=frame.parentElement;frame.remove();media.querySelector('.nf-testimonial-launch').hidden=false;}
        });
      };
      all('[data-testimonial-video]').forEach(link => link.addEventListener('click', e => {
        if (e.defaultPrevented) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        const media = link.parentElement;
        stopOtherStories(null);
        link.hidden = true;
        if (link.dataset.youtube) {
          const frame = document.createElement('iframe');
          frame.src = 'https://www.youtube-nocookie.com/embed/' + link.dataset.youtube + '?autoplay=1&playsinline=1&rel=0';
          frame.title = link.dataset.title + ' — NeuroMD video testimonial';
          frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
          frame.allowFullscreen = true;
          frame.referrerPolicy = 'strict-origin-when-cross-origin';
          media.append(frame);
          frame.focus({preventScroll:true});
        } else {
          const player = document.createElement('video');
          player.controls = true;
          player.playsInline = true;
          player.preload = 'none';
          player.src = link.href;
          player.poster = link.querySelector('img').src;
          player.setAttribute('aria-label',link.dataset.title + ' — NeuroMD video testimonial');
          player.addEventListener('play', () => {if (!player.paused) stopOtherStories(player);});
          media.append(player);
          player.focus({preventScroll:true});
          player.play().catch(() => {});
        }
      }, true));
    }
    // Handle clinician playback before the theme's generic YouTube lightbox listener.
    all('[data-expert-video]').forEach(link => link.addEventListener('click', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      const media = one('.nf-expert-video');
      let frame = media.querySelector('iframe');
      if (!frame) {
        all('.nf-testimonial-media video').forEach(video => video.pause());
        all('.nf-testimonial-media iframe').forEach(other => {other.parentElement.querySelector('.nf-testimonial-launch').hidden=false;other.remove();});
        media.querySelector('.nf-expert-launch').hidden = true;
        frame = document.createElement('iframe');
        frame.src = 'https://www.youtube-nocookie.com/embed/9NVVi1gyFIc?autoplay=1&playsinline=1&rel=0';
        frame.title = 'Mark Rosenberg — clinician perspective on NeuroMD';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.allowFullscreen = true;
        frame.referrerPolicy = 'strict-origin-when-cross-origin';
        media.append(frame);
      }
      frame.focus({preventScroll:true});
    }, true));
    // The badge's review link should reveal the actual clinician section.
    const clinicianMessage = e => {
      if (e.origin !== 'https://app.thefrontrowhealth.com' || e.source !== one('#iframe-frontrow-quant')?.contentWindow) return;
      if (e.data === 'SCROLL_TO_TESTIMONIALS') one('#nf-clinicians')?.scrollIntoView({behavior:reduced.matches ? 'instant' : 'smooth'});
    };
    window.addEventListener('message', clinicianMessage);
    all('[data-scroll-prev],[data-scroll-next]').forEach(b => b.addEventListener('click', () => {
      const rail = b.closest('.nf-wrap').querySelector('.nf-scroll');
      rail.scrollBy({left:rail.clientWidth * (b.hasAttribute('data-scroll-next') ? .8 : -.8), behavior:reduced.matches ? 'instant' : 'smooth'});
    }));
    const form = one('[data-nf-cart-form]');
    if (form) {
      const purchaseButtons = all('[data-add],[data-sticky-add]');
      const quantity = form.elements.quantity;
      all('[data-quantity]').forEach(b => b.addEventListener('click', () => { quantity.value = Math.max(1, Math.min(99, (parseInt(quantity.value, 10) || 1) + Number(b.dataset.quantity))); }));
      const variants = JSON.parse(one('[data-product-variants]').textContent);
      const select = one('[data-variant-select]');
      if (select) select.addEventListener('change', () => {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        all('[data-price]').forEach(e => e.textContent = form.dataset.trialCheckout ? (e.dataset.trialPrice || form.dataset.trialPrice || '$0 NOW') : variant.price);
        all('[data-compare]').forEach(e => {e.textContent = variant.compare; e.hidden = !variant.onSale || (Boolean(form.dataset.trialCheckout) && Boolean(e.closest('[data-sticky]')));});
        const saving = one('[data-saving]'); saving.hidden = Boolean(form.dataset.trialCheckout) || !variant.onSale; saving.textContent = `You save ${variant.saving}`;
        purchaseButtons.forEach(button => { button.disabled = !variant.available; button.querySelector('span').textContent = variant.available ? (form.dataset.trialCheckout ? (form.dataset.trialLabel || 'Start My Home Trial') : (button.hasAttribute('data-sticky-add') ? 'Get my kit' : 'Get my NeuroMD kit')) : 'Sold out'; });
      });
      // Keep this page's cart flow independent of global cart-app click handlers.
      purchaseButtons.forEach(button => button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.requestSubmit(event.currentTarget);
      }, true));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!form.reportValidity()) return;
        const button = one('[data-add]');
        if (button.disabled) return;
        if (form.dataset.trialCheckout) {
          window.location.assign(form.dataset.trialCheckout);
          return;
        }
        const status = one('.nf-cart-status');
        const stickyStatus = one('.nf-sticky-cart-status');
        const setStatus = text => { status.textContent = text; if (stickyStatus) stickyStatus.textContent = text; };
        const labels = purchaseButtons.map(button => ({button, label:button.querySelector('span'), text:button.querySelector('span').textContent}));
        const restoreButtons = () => labels.forEach(({button,label,text}) => { button.disabled = false; label.textContent = text; });
        labels.forEach(({button,label}) => { button.disabled = true; label.textContent = 'Adding…'; });
        setStatus('');
        try {
          const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {method:'POST', body:new FormData(form), headers:{Accept:'application/json'}});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add the kit. Please try again.');
          setStatus('Added to your cart. Opening cart…');
          // The store's slidecart loads asynchronously; allow it time to initialize.
          for (let attempt = 0; attempt < 50 && typeof window.HS_SLIDE_CART_OPEN !== 'function'; attempt++) {
            await new Promise(resolve => setTimeout(resolve, 100));
          }
          if (typeof window.HS_SLIDE_CART_OPEN === 'function') {
            if (typeof window.HS_SLIDE_CART_UPDATE === 'function') window.HS_SLIDE_CART_UPDATE();
            window.HS_SLIDE_CART_OPEN();
            setStatus('Added to your cart.');
          } else {
            setStatus('Your kit was added. The cart drawer is taking longer to load. ');
            const cartLink = document.createElement('a');
            cartLink.href = root.dataset.cartUrl;
            cartLink.textContent = 'View your cart';
            status.appendChild(cartLink);
            if (stickyStatus) stickyStatus.appendChild(cartLink.cloneNode(true));
          }
          restoreButtons();
        } catch (error) {
          setStatus(error.message === 'Failed to fetch' ? 'Connection interrupted. Please check your cart before trying again.' : error.message);
          restoreButtons();
        }
      }, true);
    }
    // Animate the routine using passive scroll observation; never alter page scrolling.
    const routine = one('[data-routine]');
    let routineFrame = 0;
    const routineStages = routine ? [...routine.querySelectorAll('.nf-routine-stage')] : [];
    const updateRoutine = () => {
      routineFrame = 0;
      if (!routine) return;
      const list = routine.querySelector('.nf-routine-stages');
      const markers = routineStages.map(stage => stage.querySelector('.nf-routine-marker').getBoundingClientRect());
      const rect = routine.getBoundingClientRect();
      const first = markers[0].top + markers[0].height / 2;
      const last = markers[3].top + markers[3].height / 2;
      routine.style.setProperty('--routine-line-top', `${first - list.getBoundingClientRect().top}px`);
      routine.style.setProperty('--routine-line-end', `${Math.max(0, list.getBoundingClientRect().bottom - last)}px`);
      routine.classList.toggle('is-entered', reduced.matches || rect.top < innerHeight * .9);
      let progress = (innerHeight * .48 - first) / Math.max(1, last - first);
      progress = reduced.matches ? 1 : Math.max(0, Math.min(1, progress));
      routine.style.setProperty('--routine-scale', progress);
      const thresholds = markers.map(m => (m.top + m.height / 2 - first) / Math.max(1,last-first));
      let active = -1;
      thresholds.forEach((t,i) => {if (progress >= t && (reduced.matches || first <= innerHeight*.48)) active=i;});
      routineStages.forEach((stage,i) => {
        const complete = reduced.matches || i < active;
        stage.classList.toggle('is-complete',complete);
        stage.classList.toggle('is-active',!reduced.matches && i === active);
        if (complete || i === active) stage.classList.add('was-active');
      });
    };
    const requestRoutineUpdate = () => {if (!routineFrame) routineFrame = requestAnimationFrame(updateRoutine);};
    const routineResize = routine ? new ResizeObserver(requestRoutineUpdate) : null;
    if (routine) {
      routine.classList.add('is-enhanced');
      routineResize.observe(routine);
      window.addEventListener('scroll',requestRoutineUpdate,{passive:true});
      window.addEventListener('resize',requestRoutineUpdate);
      reduced.addEventListener('change',requestRoutineUpdate);
      updateRoutine();
    }
    const sticky = one('[data-sticky]');
    let pastBuyBox = false; let footerVisible = false;
    const syncSticky = () => { sticky.hidden = !pastBuyBox || footerVisible || !form; };
    const observer = new IntersectionObserver(([entry]) => {
      pastBuyBox = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      syncSticky();
    }, {threshold:0});
    observer.observe(one('#nf-buy'));
    const footerObserver = new IntersectionObserver(([entry]) => {footerVisible=entry.isIntersecting;syncSticky();});
    const footer = document.querySelector('.site-footer'); if (footer) footerObserver.observe(footer);
    document.addEventListener('shopify:section:unload', e => { if (e.detail.sectionId === root.dataset.sectionId) {observer.disconnect();footerObserver.disconnect();galleryResize.disconnect();storyResize?.disconnect();all('.nf-testimonial-media video').forEach(v=>v.pause());routineResize?.disconnect();cancelAnimationFrame(routineFrame);window.removeEventListener('scroll',requestRoutineUpdate);window.removeEventListener('resize',requestRoutineUpdate);reduced.removeEventListener('change',requestRoutineUpdate);window.removeEventListener('message', clinicianMessage);} }, {once:true});
  };
  const initialize = () => document.querySelectorAll('[data-neuromd-freebird]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
